<div class="d-flex">
  <app-tabs-form [activeForm]="activeForm" [account_type]="account_type" [draft]="draft" [role]="role"
    [updatesTabs]="updatesTabs" [document_buttons_chico]="document_buttons_chico"></app-tabs-form>

  <div class="card w-100 form-right">
    <div class="back">
      <h2 *ngIf="!draft">{{ "forms.names.addorder" | translate }}</h2>

      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="form">
          <div >
            <div>
              <div >
                <div class="form-section">
                  <span>{{ "forms.labels.create_order_with_documents" | translate }}</span>

                  <div class="drop-zone" (drop)="onDrop($event)" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (click)="fileInput.click()">
                    {{ "forms.labels.draganddrop" | translate }}
                    <input #fileInput type="file" multiple class="input-file-hidden" (change)="onFileInputChange($event)" />
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="div-form"></div>

      <!--    <div class="btn-send d-flex align-items-center justify-content-between w-100 ml-4">
        <button *ngIf="!draft" type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()"></button>
      </div> -->
    </div>
  </div>
</div>
